// import 'bootstrap/dist/css/bootstrap.css'
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'swiper/css/bundle'
import "./styles/index.scss";
import * as serviceWorker from "./serviceWorker";
import Provider from "./context";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Provider>
                <App />
            </Provider>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
